import { combineReducers } from "redux";
import status from "./statusReducer";
import paginate from "./paginateReducer";
import selected from "./selectedReducer";
import snackbars from "./snackbarReducer";
import theme from "./themeReducer";
import modal from "./modalReducer";
import policie from "./policieReducer";

export default combineReducers({
  status,
  paginate,
  selected,
  snackbars,
  theme,
  modal,
  policie
});
